import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import { useSettings } from "../hooks/useSettings";
import Logo from "./assets/logo.png";

const Header = ({ alignWithBoxedPage = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeNav, setActiveNav] = useState("/");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { settings, isLoading: loading } = useSettings();
  const location = useLocation();

  // Track active nav based on current URL
  useEffect(() => {
    setActiveNav(location.pathname);
  }, [location.pathname]);

  const handleNavClick = (navItem) => {
    setActiveNav(navItem);
    setIsMenuOpen(false);
  };

  const toggleDropdown = (menu) => {
    setActiveDropdown((prevMenu) => (prevMenu === menu ? null : menu));
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  return (
    <>
      <header className="bg-[#BA1500] text-white sticky z-[9999]">
        {/* On a boxed page the text starts 33px in from the container edge
            (main's 16px gutter + the box's 1px border + its 16px padding), so
            the logo moves onto that line, and the nav row below moves over
            17px so the HOME label (after its own 16px padding) lands there too. */}
        <div
          className={`container mx-auto flex justify-between items-center py-3 ${
            alignWithBoxedPage ? "pl-[33px] pr-4" : "px-4"
          }`}
        >
          <Link
            to="/"
            className="flex items-center"
            onClick={() => handleNavClick("/")}
          >
            <img
              src={settings?.logoUrl || settings?.logoPath || Logo}
              alt="Logo"
              className="h-16 w-16 mr-4"
            />
            <div>
              <h1 className="text-xl md:text-3xl font-bold uppercase text-white">
                {settings?.clubName || "Community"}
              </h1>
              <p className="text-sm italic">
                {settings?.clubSubtitle || ""}
              </p>
            </div>
          </Link>

          <div className="hidden lg:block text-right">
            <p className="text-lg font-semibold">
              {settings?.phoneNumber || "+1 561-702-3795"}
            </p>
            <p className="text-sm">
              {settings?.email || ""}
            </p>
          </div>

          <button
            className="lg:hidden block text-2xl"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            ☰
          </button>
        </div>

        <nav
          className={`bg-[#d00d0e] transition-all duration-300 lg:block font-bold ${isMenuOpen ? "block" : "hidden"
            }`}
        >
          <ul
            className={`container mx-auto flex flex-col lg:flex-row lg:gap-6 text-sm py-2 lg:py-2 uppercase font-bold ${
              alignWithBoxedPage ? "pl-[17px]" : ""
            }`}
          >
            {settings?.navItems
              ?.filter((navItem) => navItem.status === true)
              .map((navItem) => {
                // COMMUNITY link: render as simple link, no submenus
                const isCommunity = String(navItem.label || "").toLowerCase() === "community";
                const isDropdown = !isCommunity && (
                  (navItem.type &&
                    String(navItem.type).toUpperCase() === "DROPDOWN") ||
                  (navItem.dropdownItems && navItem.dropdownItems.length > 0)
                );
                return (
                  <li
                    key={navItem.id}
                    className={isDropdown ? "relative cursor-pointer" : ""}
                    onMouseLeave={isDropdown ? handleMouseLeave : undefined}
                    onClick={() => isDropdown && toggleDropdown(navItem.label)}
                  >
                    {isDropdown ? (
                      <>
                        <div
                          className={`hover:bg-[#BA1500] px-4 py-1 flex justify-between lg:justify-center items-center ${activeNav === navItem.label.toLowerCase()
                              ? "bg-[#BA1500]"
                              : ""
                            }`}
                        >
                          <span>{navItem.label}</span>
                          <IoMdArrowDropdown size={32} />
                        </div>
                        {activeDropdown === navItem.label && (
                          <ul className="absolute z-50 left-0 w-full md:w-48 bg-white text-black shadow-md rounded-md capitalize font-bold">
                            {(navItem.dropdownItems || [])
                              .filter((d) => d.status !== false)
                              .map((dropdownItem) => (
                                <li key={dropdownItem.id}>
                                  <Link
                                    to={dropdownItem.path}
                                    className={`hover:bg-[#BA1500] hover:text-white text-[#003049] px-4 py-2 block ${activeNav ===
                                        dropdownItem.label.toLowerCase()
                                        ? "bg-[#BA1500] text-white"
                                        : ""
                                      }`}
                                    onClick={() =>
                                      handleNavClick(
                                        dropdownItem.label.toLowerCase()
                                      )
                                    }
                                  >
                                    {dropdownItem.label}
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <Link
                        to={navItem.path}
                        className={`hover:bg-[#BA1500] px-4 py-2 block ${activeNav === navItem.path ? "bg-[#BA1500]" : ""
                          } ${navItem.path === "/" ? "font-extrabold" : ""}`}
                        onClick={() => handleNavClick(navItem.path)}
                      >
                        {navItem.label}
                      </Link>
                    )}
                  </li>
                );
              })}
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
